import { BsSubjectPermissionManagementPageHeaderTab } from './BsSubjectPermissionManagementPageHeaderTab';
export default BsSubjectPermissionManagementPageHeaderTab;
